'use strict';

var page = require('./page');
var DataLayerConstants = require('../../../bc_sheplersbootbarn_core/cartridge/js/DataLayerConstants');
var GoogleTagManagerClient = require('../../../bc_sheplersbootbarn_core/cartridge/js/util/GoogleTagManagerClient');
var SiteConstants = require('../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');

var isCheckout, isEchoCart, fnUpdateCart, fnRenderCart, $focusedElement;
var loadingIndicatorSettings = {
    IsLabelShown: false,
    CssClass: 'fullscreen',
    BackgroundColor: 'transparent'
};

function updateStepperQtyUI($this, increment) {
	var $quantityStepper = increment != undefined ? $this.parent('.quantity-stepper') : $this;
	var $input = $quantityStepper.find('input.input-text');
	var quantity = parseInt($input.val());
	// Only increment or decrement quantity if a boolean was passed into the function
	if (increment != undefined) {
		increment ? quantity++ : quantity--;
	}
	
	// Enable or Disable the plus/minus signs on the quantity stepper
	var $incButton = $quantityStepper.find('button.increase.plus');
	var $decButton = $quantityStepper.find('button.decrease.minus');

	if (quantity <= 1) {
		$decButton.addClass('disabled').attr('disabled', 'disabled');
		$incButton.removeClass('disabled').removeAttr('disabled');
	} else if (quantity > 1) {
		$decButton.removeClass('disabled').removeAttr('disabled');
		$incButton.removeClass('disabled').removeAttr('disabled');
	}

	// Update the value of the quantity stepper
	$input.attr('quantity-buffer', quantity);
	$input.val(quantity);
}

function updateMiniCartUI(increment, $lineItem) {
	var $miniCartElm = $('.mini-cart .minicart-quantity').length > 0 ? $('.mini-cart .minicart-quantity') : $('.mini-cart .btn-minicart .btn-minicart-qty');
	var miniCartTotal;
	if ($miniCartElm.length > 0) {
		miniCartTotal = parseInt($miniCartElm.html().trim());
	}

	if ((increment != null && typeof increment === "boolean") && !$lineItem) {
		increment ? miniCartTotal++ : miniCartTotal--;
	} else if ((increment == null || typeof increment != "boolean") && $lineItem) {
		var itemQty = parseInt($lineItem.find('.opc-qty').val());
		miniCartTotal = itemQty && typeof itemQty == 'number' && itemQty > 0 ? miniCartTotal - itemQty : miniCartTotal;
		$lineItem.remove();
	}
	
	// Update the basket quantity on the main navigation bar > minicart icon
	miniCartTotal >= 1 ? $miniCartElm.html(miniCartTotal) : $miniCartElm.html(0);

	// Update the minicart modal, if it's currently open
	if ($('.add-to-cart-modal').length > 0) {
		var productRecommendationsHtml = $('.add-to-cart-modal  .main-content .product-recommendations-container').html();
		$.ajax({url : Urls.addToCartModalDisplay, dataType: 'html', success : function(modalContent) {
			if (modalContent.length > 0) {
				$('.add-to-cart-modal .ui-dialog-content').html(modalContent);
				$('.add-to-cart-modal-content .main-content .product-recommendations-container').append(productRecommendationsHtml);
				// Reference addToCart.js > addItemToCart() > line 314 (Move title from main content to top of the modal)
				if ($('.add-to-cart-modal-content').length > 0) {
					var $addMessage = $('.add-to-cart-modal-content .main-content .added-message');
					// Reference addToCart.js > addItemToCart() > line 377 (Inserts the word 'Item' into the minicart title)
					$('.add-to-cart-modal-content .added-message .count').text('Item');
					if ($addMessage.length > 0) {
						$('.add-to-cart-modal-content').prepend($addMessage);
					}
				}
			}
		}});
	}
}

function updateCartTotals() {
	if (isCheckout && fnUpdateCart) {
		fnUpdateCart($('.update-cart-button').attr('name'));
	}
	if (isEchoCart && fnRenderCart) {
		fnRenderCart();
	}
}

function removeFromCartDataLayer($this) {
	try {
		var $item = $this.closest('[data-uuid]');
		if ($item) {
			var productID = $item.attr('data-productid');
			var $element, uaObject, ga4Object, productDataForUniversalAnalytics, productDataForGoogleAnalytics4;
			$('.add-to-cart-analytics-container').each(function(idx, elm) {
				$element = $(elm);
				if ($element) {
					uaObject = JSON.parse($element.attr('data-product-gtm-json'));
					ga4Object = JSON.parse($element.attr('data-product-ga4-json'));
					
					if (uaObject && uaObject.skuid && uaObject.skuid == productID) {
						productDataForUniversalAnalytics = uaObject;
						productDataForGoogleAnalytics4 = ga4Object;
					}
				}
			});

			if (productDataForUniversalAnalytics && productDataForGoogleAnalytics4) {
				var dataObject = {
					UniversalAnalytics: {
						ecommerce: {
							remove: {
								products: [productDataForUniversalAnalytics]
							}
						}
					},							
					GoogleAnalytics4: {
						value: productDataForGoogleAnalytics4.price,
						items: [productDataForGoogleAnalytics4]
					}
				}

				GoogleTagManagerClient.PushDataLayerForDataLayerType('RemoveFromCart', dataObject);
			}
		}
	} catch(e) {
	}
}

function quantityDatalayerEvents($this, eventType, quantity) {
	try {
		var $item = $this.closest('[data-uuid]');
		if ($item) {
			var eventName;
			var ecommerceKey;
			if (eventType == DataLayerConstants.EventTypes.Minus) {
				eventName = DataLayerConstants.Events.Cart.RemoveFromCart.Name;
				ecommerceKey = 'remove';
			} else {
				eventName = DataLayerConstants.Events.Cart.AddToCart.Name;
				ecommerceKey = 'add';
			}
			var productID = $item.attr('data-productid');
			var $element, uaObject, ga4Object, productDataForUniversalAnalytics, productDataForGoogleAnalytics4;
			$('.add-to-cart-analytics-container').each(function(idx, elm) {
				$element = $(elm);
				if ($element) {
					uaObject = JSON.parse($element.attr('data-product-gtm-json'));
					ga4Object = JSON.parse($element.attr('data-product-ga4-json'));
					
					if (uaObject && uaObject.skuid && uaObject.skuid == productID) {
						productDataForUniversalAnalytics = uaObject;
						productDataForGoogleAnalytics4 = ga4Object;
					}
				}
			});
			
			if (productDataForUniversalAnalytics && productDataForGoogleAnalytics4) {
				if (quantity) {
					productDataForUniversalAnalytics.quantity = quantity;
					productDataForGoogleAnalytics4.quantity = quantity;
				}

				var dataObject = {
					UniversalAnalytics: {
						ecommerce: {}
					},							
					GoogleAnalytics4: {
						value: productDataForGoogleAnalytics4.price,
						items: [productDataForGoogleAnalytics4]
					}
				}

				dataObject.UniversalAnalytics.ecommerce[ecommerceKey] = {
					products: [productDataForUniversalAnalytics]
				}

				GoogleTagManagerClient.PushDataLayerForDataLayerType(eventName, dataObject);
			}
		}
	} catch(e) {
	}
}

function quantityChangeEvents($this, quantity, increment) {
	var eventType = increment ? DataLayerConstants.EventTypes.Plus : DataLayerConstants.EventTypes.Minus;
	quantityDatalayerEvents($this, eventType, quantity);
}

function spinnerClear() {
	var spinnerTimer;
	var timerIncrement = isCheckout || isEchoCart ? 5000 : 2000;

	clearTimeout(spinnerTimer);
	spinnerTimer = setTimeout(function() {
		if ($('body').attr('loading')) {
			$('body').loading('destroy');
		}
	}, timerIncrement);
}

function initialize(updateCart, renderCart) {
	isCheckout = (pageContext && pageContext.type == 'cart' || pageContext.type == 'onepcheckout' || pageContext.type == 'onepcheckout_groups') || (page.ns && page.ns == 'cart' || page.ns == 'onepcheckout' || page.ns == 'onepcheckout_groups');
	isEchoCart = (pageContext && 'type' in pageContext && pageContext.type == 'cart_echo') || (page.ns && page.ns == 'cart_echo');
	fnUpdateCart = updateCart && typeof updateCart === 'function' ? updateCart : null;
	fnRenderCart = renderCart && typeof renderCart === 'function' ? renderCart : null;

	// Remove Button
	$(document).off('click.QuantityStepper.ProductRemove').on('click.QuantityStepper.ProductRemove', '.quantity-stepper-remove .remove', function (event) {
		event.preventDefault();

		var $this = $(this);
		var $itemRow = $this.closest('[data-uuid]');
		var isMiniCart = $itemRow.attr('class').indexOf('mini-cart') > -1;

		$('body').loading(loadingIndicatorSettings);
		$.ajax({
			type: 'POST',
			url: Urls.Cart.RemoveProduct,
			contentType: 'application/json',
			data: JSON.stringify({
				ProductLineItemUUID: $itemRow.data('uuid'),
			}),
			dataType: 'json',
			complete: function(xhr) {
				try {
					updateCartTotals();
					removeFromCartDataLayer($this);
					if (isMiniCart) {
						updateMiniCartUI(null, $itemRow);
					}
					spinnerClear();
				} catch(e) {
                    console.log(e);
					$('body').loading('destroy');
                }
			}
		});
	});

	// Plus/Minus Qty Buttons
	$(document).off('click.QuantityStepper.QuantityChange').on('click.QuantityStepper.QuantityChange', '.quantity-stepper button:not(".disabled")', function (event) {
		event.preventDefault();

		var $stepperButton = $(this);
		var isIncrement = $stepperButton.hasClass('increase');
		var cartQtyUrl = isIncrement ? Urls.Cart.AddProductQuantity : Urls.Cart.RemoveProductQuantity;

		$focusedElement = $stepperButton;
		$('body').loading(loadingIndicatorSettings);
		$.ajax({
			type: 'POST',
			url: cartQtyUrl,
			contentType: 'application/json',
			data: JSON.stringify({
				ProductLineItemUUID: $(this).closest('[data-uuid]').data('uuid'),
				Quantity: 1
			}),
			dataType: 'json',
			complete: function(xhr) {
				try {
                    updateStepperQtyUI($stepperButton, isIncrement);
					updateMiniCartUI(isIncrement);
					updateCartTotals();
					quantityChangeEvents($stepperButton, 1, isIncrement);
					spinnerClear();
                } catch(e) {
                    console.log(e);
					$('body').loading('destroy');
                }
			}
		});
	});

	// Input event event is reliable and fires after any user action that modifies the input field, including: keyup, paste or change
	$(document).off('input.QuantityStepper.QuantityChange').on('input.QuantityStepper.QuantityChange', '.quantity-stepper input[name$=_quantity]', function (event) {
		var args = {
			element: $(this), 
			value: $(this).val(),
			event: 'input'
		};
		$(document).trigger('QuantityStepper.InputChange', args);
	});

	$(document).off('blur.QuantityStepper.InputBlur').on('blur.QuantityStepper.InputBlur', '.quantity-stepper input[name$=_quantity]', function (event) {
		var args = {
			element: $(this), 
			value: $(this).val(),
			event: 'blur'
		};
		$(document).trigger('QuantityStepper.InputChange', args);
	});

	// Custom-Named event for the keyboard or paste input for quantity field
    $(document).off('QuantityStepper.InputChange').on('QuantityStepper.InputChange', function (event, args) {
		var $this = $(args.element);
		var triggerEvent = args.event;
		var numericValue = parseInt(args.value);
		if (isNaN(numericValue) || numericValue <= 0 || numericValue === parseInt($this.attr('quantity-buffer'))) {
			if (triggerEvent === 'blur') {
				$this.val($this.attr('quantity-buffer'));
			} else {
				if (args.value != '') {
            		$this.val($this.attr('quantity-buffer')); 
				}
			}
		} else {
			var quantityDelta = numericValue - parseInt($this.attr('quantity-buffer'));
			var isIncrement = quantityDelta < 0 ? false : quantityDelta > 0 ? true : null;
			if (isIncrement != null) {
				var cartQtyUrl = isIncrement ? Urls.Cart.AddProductQuantity : Urls.Cart.RemoveProductQuantity;

				$('body').loading(loadingIndicatorSettings);
				$.ajax({
					type: 'POST',
					url: cartQtyUrl,
					contentType: 'application/json',
					data: JSON.stringify({
						ProductLineItemUUID: $this.closest('[data-uuid]').data('uuid'),
						Quantity: Math.abs(quantityDelta)
					}),
					dataType: 'json',
					complete: function(xhr) {
						try {
							updateStepperQtyUI($this, isIncrement);
							updateMiniCartUI(isIncrement);
							updateCartTotals();
							quantityChangeEvents($this, Math.abs(quantityDelta), isIncrement);
							$this.attr('quantity-buffer', numericValue);
							spinnerClear();
						} catch(e) {
							console.log(e);
							$('body').loading('destroy');
						}
					}
				});
			}
			$focusedElement = $this;	
		}
	});

	$(document).off('QuantityStepper.TargetFocus').on('QuantityStepper.TargetFocus', function () {
		if ($focusedElement) {
			$focusedElement.focus();
		}
	});
}

exports.init = initialize;